<template>
  <div class="ticket">
    <div
      v-if="status!=null"
      class="ticket-wrap"
      :class="status==0?'act':'default'"
    >
      <div class="info">{{info}}</div>
      <div
        class="use"
        @click="popupShow=true"
        v-if="status==0"
      ></div>
    </div>
    <div
      class="py-4 mt-5"
      v-if="status==null"
    >

      <div class="bold"> 温馨提示：</div>
      <div class="mb-10">您还未领到特惠购书券，快来领取购书券吧。</div>
      <van-button
        block
        class="share-btn"
        @click="userFormShow++"
      >领取购书券</van-button>
    </div>
    <div
      class="py-4 mt-5"
      v-else
    >
      <div class="bold"> 使用规则：</div>
      <div>在活动期间，凭特惠购书券可到完美金鹰广场正门旁（星巴克门口旁）第十三届中山书展惠民书屋购买相应的图书最多五本，以图书定价的10%结算，图书数量有限，先到先得。</div>
    </div>
    <div class="mt-11">
      <van-button
        block
        class="share-btn"
        @click="shareShow=true"
      >我要分享</van-button>
    </div>

    <div
      class="share"
      v-show="shareShow"
      @click="shareShow=false"
    >
      <img
        src="@/assets/images/share-arrow.png"
        alt=""
        class="share-pic"
      >
      <div class="text bold">点击右上角按钮，分享给朋友，一起来领券吧！</div>
    </div>
    <van-popup
      v-model="popupShow"
      :close-on-popstate="true"
      :close-on-click-overlay="false"
      :close-icon="require('@/assets/images/icon-close.png')"
      :closeable="true"
      @closed="resetForm"
    >
      <van-form
        @submit="onSubmit"
        :show-error="false"
        label-width="0"
        ref="form"
      >
        <div class="t-center mt-5 fs-4-5">请输入消券码</div>
        <van-field
          class="mt-5 mb-5 input-style"
          v-model="code"
          name="code"
          placeholder="请输入消券码"
          :border="false"
          :rules="[{ required: true, message: '请输入消券码' }]"
        />
        <div
          class="tip mb-10"
          style="color:rgb(115, 112, 112)"
        >请到前台联系工作人员输入消券码</div>

        <van-button
          block
          type="info"
          native-type="submit"
          :disabled="loading"
          :loading="loading"
          loading-text="确定"
        >确定</van-button>
      </van-form>
    </van-popup>

    <user-info-form
      :formshow="userFormShow"
      :isvote="true"
      @closetip="getTicketInfo"
    />

    <!-- <div v-if="isVote == 1 && isWriteInfo == 0">
      <user-info-form
        :formshow="1"
        :isvote="true"
        @closetip="getTicketInfo"
      />
    </div> -->
  </div>
</template>

<script>
import { getTicketInfo, useTicket, userStatus } from '@/api'
import { Dialog, Form, Field, Popup, Button } from 'vant'
import UserInfoForm from '@/components/UserInfoForm.vue'
export default {
  name: 'Ticket',
  components: {
    UserInfoForm,
    [Dialog.Component.name]: Dialog.Component,
    [Popup.name]: Popup,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
  },
  data() {
    return {
      info: '',
      status: null,
      shareShow: false,
      popupShow: false,
      code: '',
      loading: false,
      userFormShow: 0,
      isvote: true,
      isVote: null, //0未投票，1已投票
      isWriteInfo: null //0未填写信息，1已填写信息
    }
  },
  created() {
    this.getTicketInfo()
    this.getUserStatus()
  },
  methods: {
    onSubmit(value) {
      this.loading = true
      useTicket(value).then(() => {
        this.loading = false
        this.getTicketInfo()
        this.getUserStatus()
        this.resetForm()
        this.$toast("使用成功")
        setTimeout(() => {
          this.popupShow = false
        }, 1000);
      }).catch(() => {
        this.loading = false
      })
    },
    // 获取用户投票状态和填写个人信息状态
    getUserStatus() {
      userStatus().then((res) => {
        this.isVote = res.data.is_vote
        this.isWriteInfo = res.data.is_write_info
      })
    },
    // 获取券信息
    getTicketInfo() {
      getTicketInfo().then((res) => {
        const list = res.data.list[0]
        this.status = list.status
        this.info = list.info
      })
    },
    resetForm() {
      this.code = ''
      this.$refs.form.resetValidation()
    }
  }
}
</script>
<style scoped>
.ticket {
  padding: 8vw 6vw;
  color: #333;
  font-size: 3.5vw;
  text-align: justify;
}
.ticket-wrap {
  position: relative;
  width: 87.7vw;
  height: 34.4vw;
  cursor: pointer;
}
.ticket-wrap.act {
  background: url(../assets/images/ticket.png) top center/100% no-repeat;
  color: #eb6100;
}
.ticket-wrap.default {
  background: url(../assets/images/ticket-default.png) top center/100% no-repeat;
  color: #999;
}
.ticket-wrap .info {
  font-size: 3.5vw;
  position: absolute;
  left: 6vw;
  bottom: 9vw;
}
.use {
  width: 11vw;
  height: 25vw;
  position: absolute;
  right: 5.2vw;
  top: 4vw;
  z-index: 2;
}
.share {
  background-color: #252525;
  position: fixed;
  width: 100vw;
  height: 100vh;
  color: #fff;
  font-size: 6.2vw;
  top: 0;
  left: 0;
  padding: 0 5vw;
  box-sizing: border-box;
}
.share-pic {
  width: 40vw;
  margin-left: 50vw;
}
.share-btn {
  margin-bottom: 10.4vw;
}
</style>
